import React, { useEffect, useState } from 'react';
import { Table, Space, Select } from 'antd';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'components/atoms'
import * as XLSX from 'xlsx';

interface FormItemProps {
  salesList: any[] | undefined;  
  hiddenColumns: string[];  
  codeList: any[] | undefined;
  actPage: string;
  detailCode: string;
  year: string;
  startMonth: string;
  endMonth: string;
  months: any[] | undefined;
  onChangeDetailMonth: (start:string, end:string, value:string) => void;
}

const SALESNTable = ({salesList, hiddenColumns, codeList, actPage, detailCode, months, year, startMonth, endMonth, onChangeDetailMonth}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [viewColumns, setViewColumns] = useState<any[]>([]);
  const [viewColumnCnt, setViewColumnCnt] = useState<number>(0);

  const sharedOnCell = (record) => {
    if (record.type === 'total') {
      return { colSpan: 0 };
    }
    return {};
  };

  const columns: ColumnsType<any> = [
    {
      title: '진행',
      dataIndex: 'project_step',
      key: 'project_step',
      width: '50px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },      
    {
      title: '고객NO',
      dataIndex: 'group_id',
      key: 'group_id',
      width: '130px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },       
    {
      title: '기업명',
      dataIndex: 'group_company',
      key: 'group_company',
      width: '130px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    }, 
    {
      title: '매출',
      dataIndex: 'max_price',
      key: 'max_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },      
    {
      title: '프로젝트 건수',
      dataIndex: 'project_cnt',
      key: 'project_cnt',
      width: '120px',
      align: 'right',
      onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();

                if (record.project_cnt  && record.project_cnt > 0) {
                  if (record.project_step === 'A') {
                    window.open(`/b2b/confirm?company=${record.group_id}`);
                  } else if (record.project_step === 'B') {
                    window.open(`/b2b/consult?company=${record.group_id}`);
                  }
                }
              },
          };
      },
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    }, 
    {
      title: '공개과정 인원수',
      dataIndex: 'student_cnt',
      key: 'student_cnt',
      width: '120px',
      align: 'right',
      onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();

                if (record.student_cnt  && record.student_cnt > 0) {
                  window.open(`/b2c/lecture?company=${record.group_id}`);
                }
              },
          };
      },      
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },                                               
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onExcelDownload = () => {
    const header: string[] = [];
    const datas: any[] = [];
    const merges: any[] = [];

    header.push('진행');  
    header.push('고객NO');
    header.push('기업명');
    header.push('매출');
    header.push('프로젝트 건수');
    header.push('공개과정 인원수');
    
    let tot_project = 0;
    let tot_student = 0;      
    let tot_price = 0;      
    salesList?.forEach((item, index) => {
      const newItem = {
        '진행': item.project_step,
        '고객NO': item.group_id,
        '기업명': item.group_company,
        '매출': item.max_price,
        '프로젝트 건수': item.project_cnt,
        '공개과정 인원수': item.student_cnt,
      }
      datas.push(newItem);

      tot_project += item.project_cnt?item.project_cnt:0;
      tot_student += item.student_cnt?item.student_cnt:0;          
      tot_price += item.max_price?item.max_price:0;  
    });

    const newItem = {
      '진행': '합계',
      '고객NO': '합계',
      '기업명': '합계',
      '매출': tot_price,
      '프로젝트 건수': tot_project,
      '공개과정 인원수': tot_student,      
    }
    datas.push(newItem);
    merges.push({s: {c:0, r:datas.length}, e: {c:2, r:datas.length}});

    const book = XLSX.utils.book_new();
    const nurses = XLSX.utils.json_to_sheet(
      datas, 
      { 
        header : header, 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 150 } 
    , { wpx : 150 }       
    , { wpx : 200 } 
    , { wpx : 100 }  
    , { wpx : 100 }  
    , { wpx : 100 }
    ]
    if (merges.length > 0) {
      nurses["!merges"]  = merges;   
    }

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
    XLSX.writeFile( book, year+'_'+startMonth +'월_'+endMonth+'월_매출.xlsx'); 
  }  

  useEffect(() => {
    if (!!hiddenColumns) {
      const newColumns = columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0);
      setViewColumns(newColumns);
      setViewColumnCnt(newColumns.length);
    }

  }, [hiddenColumns, salesList]);
  

  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{width:'100%', justifyContent:'space-between', marginTop:'20px'}}>
        <Space>
        {(!!codeList && codeList.length > 0) && (
          <Select 
            placeholder={"선택하세요."}
            value={detailCode}
            options={codeList}
            onSelect={(value)=>{onChangeDetailMonth(startMonth, endMonth, value)}}
            style={{width: '150px'}}
          />  
        )}   
          <Select 
            value={startMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(value, endMonth, detailCode)}}
            style={{width: '80px'}}
          /> 
          <Select 
            value={endMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(startMonth, value, detailCode)}}
            style={{width: '80px'}}
          />       
        </Space>
        <Space>
          <Button icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
        </Space>              
      </Space>
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={salesList}
          columns={viewColumns}
          pagination={false}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          summary={pageData => {
            let tot_price = 0;
            let tot_project = 0;
            let tot_student = 0;
            pageData.forEach((item) => {
              tot_project += item.project_cnt?item.project_cnt:0;
              tot_student += item.student_cnt?item.student_cnt:0;          
              tot_price += item.max_price?item.max_price:0;    
            });
            return (
              <>
                <Table.Summary.Row style={{backgroundColor:'#f7f7f7', fontWeight:'500', color:'red'}}>
                  <Table.Summary.Cell index={1} colSpan={3}  align='center'>합계</Table.Summary.Cell>
                  <Table.Summary.Cell index={9} colSpan={1} align='right'>{tot_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>
                  <Table.Summary.Cell index={10} colSpan={1} align='right'>{tot_project.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>
                  <Table.Summary.Cell index={10} colSpan={1} align='right'>{tot_student.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESNTable;
